/**
 * Do not edit directly
 * Generated on Thu, 05 Feb 2026 07:24:05 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";